export enum FieldType {
    Expertise = "expertise",
    Standard = "standard",
}

export interface FieldOption {
    value: string;
}
